import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import LayoutAuth from '../../components/LayoutAuth/index';
import ConfirmEmailContent from './components/ConfirmEmailContent';
import StepperLoading from '../Stepper/StepperLoading';
import { Helmet } from 'react-helmet-async';
import { Box, styled, useMediaQuery, useTheme } from '@mui/material';
import { getCookie, removeCookie, setCookie } from '../../utils/cookies';
import { useConfig } from '../../Hooks/useConfig';
import { useAuthStatus } from '../../store/auth/useAuthStatus';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import useUsersFacade from '../../store/profile/useUsersFacade';

const ConfirmEmail = () => {
  // const [isSuccess, setIsSuccess] = useState(false);
  const { t } = useTranslation();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const { baseDomain } = useConfig();
  const history = useHistory();
  const { userInfo, loading } = useUsersFacade();

  const { setToken } = useAuthStatus();

  useEffect(() => {
    if (!loading && userInfo?.email_verified_at !== null) {
      history.push('/');
    }
  }, [userInfo, loading, history]);

  const Logout = async () => {
    removeCookie('token', baseDomain);
    removeCookie('emailNotConfirmed', baseDomain);
    let theme = getCookie('darkMode'); //localStorage.getItem("darkMode");
    localStorage.clear();
    // localStorage.setItem("darkMode", theme);
    setCookie('darkMode', theme, 34560000, baseDomain);
    setToken('');
    await history.push('/login');
  };

  // If email is already verified, redirect immediately
  if (!loading && userInfo?.email_verified_at !== null) {
    return <Redirect to="/" />;
  }

  // If still loading, show loading state
  if (loading) {
    return <StepperLoading loading={loading} />;
  }

  // Only render the actual ConfirmEmailContent if email needs verification
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      {/* {mdDown ? <Whitespace /> : null} */}
      <LayoutAuth
        linkHelperText={t('forgot_password.linkHelperTessxt', 'Sign out')}
        linkHelperMessage={t(
          'forgot_password.linkHelperMessagssse',
          'Wrong email?'
        )}
        linkHelper="/sign-up"
        linkHelperOnClick={Logout}
        title={''}
        text={''}
        showMagicalIcon={false}
      >
        <ConfirmEmailContent />
      </LayoutAuth>
    </>
  );
};
export default ConfirmEmail;
